import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import QuienesSomos from "./components/pages/QuienesSomos";
import MarcoLegal from "./components/pages/MarcoLegal";
import TiposProyectos from "./components/pages/TiposProyectos";
import PresenteProyecto from "./components/pages/PresenteProyecto";
import FormulaCar from "./components/pages/FormulaCar";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/marco-legal" element={<MarcoLegal />} />
        <Route path="/tipos-proyectos" element={<TiposProyectos />} />
        <Route path="/presente-su-proyecto" element={<PresenteProyecto />} />
        <Route path="/formula-car" element={<FormulaCar />} />
      </Routes>
    </Router>
  );
}

export default App;
